export default __webpack_public_path__ + "static/media/banner-nohayeventos.f9a65fa6.jpg";